import { AxiosResponse } from 'axios';
import { isEmpty, trim } from 'lodash';
import axiosInstance, { axiosSmartCoolersInstance } from '@/config/apiConfig';
import {
  IFetchCoolerTransactions,
  ICoolerTransactionResponse,
} from '@/pages/CoolerTransaction/coolerTransaction.interface';
import {
  ALL_DEVICE,
  ALL_MARKET,
  ALL_OPERATOR,
} from '@/constant/global/global.constant';
import {
  COOLER_TRANSACTION_STATUS,
  COOLER_TRANSACTION_STATUS_CODES,
  COOLER_TRANSACTION_TYPES,
} from '@/pages/CoolerTransaction/constant';

export const fetchCoolerTransactions = ({
  page,
  limit,
  operatorId,
  partnerUid,
  marketId,
  deviceId,
  type,
  status,
  statusCode,
  transactionId,
  orderBy,
  order,
}: IFetchCoolerTransactions): Promise<
  AxiosResponse<ICoolerTransactionResponse>
> => {
  return axiosSmartCoolersInstance({
    url: `/transactions`,
    method: 'GET',
    params: {
      page,
      limit,
      ...(operatorId && operatorId !== '1' ? { operatorId } : {}),
      ...(partnerUid && partnerUid !== '' ? { partnerUid } : {}),
      ...(marketId && marketId !== '1' ? { marketId } : {}),
      ...(deviceId && deviceId !== '1' ? { deviceId } : {}),
      ...(type && type !== 'ALL' ? { type } : {}),
      ...(status && status !== 'ALL' ? { status } : {}),
      ...(statusCode && statusCode !== 'ALL' ? { statusCode } : {}),
      ...(transactionId && !isEmpty(trim(transactionId))
        ? { transactionId }
        : {}),
      ...(orderBy ? { orderBy } : {}),
      ...(order ? { order } : {}),
    },
  });
};

export const fetchCoolerTransaction = ({
  page,
  limit,
  operatorId,
  partnerUid,
  marketId,
  deviceId,
  type,
  status,
  statusCode,
  transactionId,
}: IFetchCoolerTransactions): Promise<
  AxiosResponse<ICoolerTransactionResponse>
> => {
  return axiosSmartCoolersInstance({
    url: `/transactions/${transactionId}`,
    method: 'GET',
    params: {
      ...(operatorId && operatorId !== ALL_OPERATOR.sourceId
        ? { operatorId }
        : {}),
      ...(partnerUid && partnerUid !== '' ? { partnerUid } : {}),
      ...(marketId && marketId !== ALL_MARKET.sourceMarketId
        ? { marketId }
        : {}),
      ...(deviceId && deviceId !== ALL_DEVICE.sourceId ? { deviceId } : {}),
      ...(type && type !== COOLER_TRANSACTION_TYPES[0].id ? { type } : {}),
      ...(status && status !== COOLER_TRANSACTION_STATUS[0].id
        ? { status }
        : {}),
      ...(statusCode && statusCode !== COOLER_TRANSACTION_STATUS_CODES[0].id
        ? { statusCode }
        : {}),
    },
  });
};
